<script setup lang="ts">
import {
  computed,
  toRef,
} from 'vue';

import VFormInputWrapper
  from '@modules/forms/components/inputs/VFormInputWrapper/VFormInputWrapper.vue';

import type {
  VFormSwitchEmits,
  VFormSwitchProps,
} from './types';
import { useInputInnerValue } from '../composables';

const props = withDefaults(defineProps<VFormSwitchProps>(), {});
const emit = defineEmits<VFormSwitchEmits>();

const { innerValue, setValue } = useInputInnerValue(toRef(props, 'value'));

const switchLabel = computed(() => {
  if (innerValue.value && props.trueLabel) {
    return props.trueLabel;
  }

  if (!innerValue.value && props.falseLabel) {
    return props.falseLabel;
  }

  return undefined;
});

function toggleValue(): void {
  if (props.disabled)
    return;

  setValue(!innerValue.value);
  emit('change', innerValue.value);
}
</script>

<template>
  <VFormInputWrapper v-data-qa-auto-id="'VFormSwitchInput'"
    :errors="errors"
    :class="isFullWidth ? 'w-full' : 'input-max-width'"
    :description="description"
    :hide-errors="hideErrors"
    :readonly="readonly"
  >
    <label
      v-if="label"
      :for="name"
      class="mb-2 block text-muted-color"
    >
      {{ label }}
    </label>
    <div class="flex items-center gap-4">
      <!-- TODO: STUB - "handle" PT, the handle doesn't move when toggle is active -->
      <PInputSwitch
        v-model="innerValue"
        :input-id="name"
        :name="name"
        :disabled="disabled || readonly"
        :required="required"
        :pt="{
          handle: {
            class: innerValue ? 'left-[1.25rem]' : '',
          },
        }"
        @change="emit('change', innerValue)"
        @input="emit('input', innerValue)"
        @blur="emit('blur', innerValue)"
        @focus="emit('focus', innerValue)"
      />
      <span
        v-if="switchLabel"
        class="cursor-pointer word-break"
        data-id="switch-label"
        :class="{ 'pointer-events-none': disabled || readonly }"
        @click="toggleValue"
      >
        {{ switchLabel }}
      </span>
    </div>
  </VFormInputWrapper>
</template>
